/*
 * NYORD: Ein-Klick-Kauf unter Produktkarten (snippets/nb-schnellkauf), genutzt von sections/nb-produkt-tabs und
 * sections/nb-zuletzt. Braucht Dawns product-form.js.
 */
// Ein-Klick-Kauf: Auswahlfeld wählt die Variante, der Preis im Knopf passt sich an.
// Nach dem Hinzufügen zeigt der Knopf kurz „Im Warenkorb“ mit Haken. Erkannt wird die fertige Anfrage an
// /cart/add über die Resource Timing API: klappt mit Dawns product-form und mit der Vitals-Warenkorbleiste,
// die das Absenden selbst übernimmt.
if (!customElements.get('nb-schnellkauf')) {
  (() => {
    let zuletzt = null;
    let beobachter = null;
    const beobachten = () => {
      if (beobachter || !('PerformanceObserver' in window)) return;
      beobachter = new PerformanceObserver((liste) => {
        const fertig = liste
          .getEntries()
          .some((e) => e.name.includes('/cart/add') && !(e.responseStatus >= 400));
        if (!fertig || !zuletzt || performance.now() - zuletzt.zeit > 15000) return;
        zuletzt.element.bestaetigen();
        zuletzt = null;
      });
      beobachter.observe({ type: 'resource' });
    };
    customElements.define(
      'nb-schnellkauf',
      class extends HTMLElement {
        connectedCallback() {
          this.eingabe = this.querySelector('input[name="id"]');
          this.knopf = this.querySelector('.nb-kauf__knopf');
          this.preis = this.querySelector('.nb-kauf__preis');
          this.werte = [...this.querySelectorAll('.nb-kauf__wert')];
          this.werte.forEach((wert) => {
            wert.addEventListener('click', () => {
              this.werte.forEach((w) => w.setAttribute('aria-checked', String(w === wert)));
              this.eingabe.value = wert.dataset.id;
              if (this.preis) this.preis.textContent = ' · ' + wert.dataset.preis;
              // Für Preisanzeigen außerhalb des Knopfs (z. B. sections/nb-showroom)
              const { preis, vorher = '', spar = '' } = wert.dataset;
              this.dispatchEvent(new CustomEvent('nb-variante', { bubbles: true, detail: { preis, vorher, spar } }));
            });
          });
          this.knopf?.addEventListener('click', () => {
            zuletzt = { element: this, zeit: performance.now() };
            beobachten();
          });
        }
        bestaetigen() {
          this.knopf.classList.add('nb-kauf__knopf--drin');
          clearTimeout(this.zeit);
          this.zeit = setTimeout(() => this.knopf.classList.remove('nb-kauf__knopf--drin'), 2400);
        }
      }
    );
  })();
}
